import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import { MenuItem, Dropdown } from 'react-bootstrap';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';

const systemUser_Url = AdminUrls.ADMIN.REPORTUSERLOGININFO;
const cpdDownloadExcel = AdminUrls.ADMIN.USERLOGININFOEXCEL;

class SystemUsageReport extends React.Component {
  constructor() {
    super();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.getCpdCompliantReport = this.getCpdCompliantReport.bind(this);
    this.searchData = this.searchData.bind(this);
    this.pageChange = this.pageChange.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdId: '',
      cpdBool: '',
      cpdMemberNum: '',
      cpdEmail: '',
      cpdUsername: '',
      cpdYear: '',
      loadCpdCompliant: [],
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      sort: {
        column: 'MemberNumber',
        direction: 'desc',
      },
      yearCpd: '',
    };
    this.controller = new AbortController();
  }

  downloadExcel(year) {
    let date = new Date();
    let newDate = date.getTime();
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(cpdDownloadExcel, {
      params: {
        Year: year,
      },
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `SystemUsageReport${newDate}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getCpdCompliantReport(pageNumber);
  }

  componentDidMount() {
    this.setState(
      {
        yearCpd: this.props.location.state,
      },
      () => {
        this.getCpdCompliantReport(1, this.props.location.state);
      }
    );
  }

  clearSearchFilters() {
    this.setState({
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdMemberNum: '',
      cpdUsername: '',
    });
    setTimeout(() => {
      this.getCpdCompliantReport(1, this?.state?.yearCpd);
    }, 1000);
  }

  getCpdCompliantReport(active, year, column, direction) {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    this.setState({
      mainLoading: true,
    });
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;

    axios
      .get(systemUser_Url, {
        params: {
          Year: year,
          page: active,
          pageSize: this.state.per_page,
          reverse: reverse,
          sortBy: sortBy,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdCompliant: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  searchData() {
    let userNames = this.state.cpdUsername;

    let pages = this.state.activePage;
    let memberNumbers = this.state.cpdMemberNum;

    let obj = {
      page: pages,
      pageSize: this.state.per_page,
      reverse: false,
    };

    if (userNames) {
      obj.UserName = userNames;
    }

    if (memberNumbers) {
      obj.MemberNumber = memberNumbers;
    }

    axios
      .get(systemUser_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdCompliant: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getCpdCompliantReport(
      this.state.activePage,
      this?.state?.yearCpd,
      column,
      direction
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  pageChange(pageQty) {
    this.setState(
      {
        per_page: pageQty,
      },
      () => {
        this.getCpdCompliantReport(this.state.activePage);
      }
    );
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadCpdCompliant;

    if (this.state?.loadCpdCompliant !== null) {
      loadCpdCompliant = this.state?.loadCpdCompliant?.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item?.MemberNumber}</td>
            <td>{item?.username}</td>
            <td>{item?.Email}</td>

            <td>{item?.CountryName}</td>
            <td>{item?.DistrictSociety}</td>
            <td>
              {item?.LastLoginTime
                ? new Date(item?.LastLoginTime).toLocaleString()
                : 'na'}
            </td>
            <td>{item?.EmployerName ? item?.EmployerName : 'na'}</td>
            <td>{item?.ExternalId}</td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>User Name</label>
                        <input
                          type="user name"
                          value={this.state.cpdUsername}
                          className="form-control"
                          id="user name"
                          onChange={(e) =>
                            this.setState({ cpdUsername: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Memebership number</label>

                        <input
                          type="memebership number"
                          className="form-control"
                          id="memebership number"
                          value={this.state.cpdMemberNum}
                          onChange={(e) =>
                            this.setState({ cpdMemberNum: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="gridTopButtons">
              <button
                type="button"
                onClick={() => window.print()}
                className="btn btn-danger btn-circle btn-lg "
              >
                <i className="fa fa-print"> </i>
              </button>

              <Dropdown id="dropdown-custom-1">
                <Dropdown.Toggle
                  className="btn btn-success btn-circle btn-lg"
                  style={{ marginLeft: '10px' }}
                  noCaret
                >
                  <i className="fa fa-file-pdf-o"> </i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel('All');
                    }}
                    eventKey="4"
                  >
                    All
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2023);
                    }}
                    eventKey="4"
                  >
                    2023
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2024);
                    }}
                    eventKey="5"
                  >
                    2024
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2025);
                    }}
                    eventKey="6"
                  >
                    2025
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2025);
                    }}
                    eventKey="7"
                  >
                    2026
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="col-md-6">
            <div className="gridTopDropdown">
              Show{' '}
              <select
                className="input-sm"
                aria-invalid="false"
                onChange={(e) => this.pageChange(e.target.value)}
              >
                <option label="10" value="10">
                  10
                </option>
                <option label="20" value="20">
                  20
                </option>
                <option label="30" value="30">
                  30
                </option>
              </select>{' '}
              entries
            </div>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('MemberNumber')}>
                  Member Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('username')}>
                  User Name <i className={this.setArrow('username')}> </i>
                </th>
                <th onClick={this.onSort('Email')}>
                  Email <i className={this.setArrow('Email')}> </i>
                </th>
                <th onClick={this.onSort('CountryName')}>
                  CountryName <i className={this.setArrow('CountryName')}> </i>
                </th>
                <th onClick={this.onSort('DistrictSociety')}>
                  DistrictSociety{' '}
                  <i className={this.setArrow('DistrictSociety')}> </i>
                </th>
                <th onClick={this.onSort('LastLoginTime')}>
                  Last Login Time{' '}
                  <i className={this.setArrow('LastLoginTime')}> </i>
                </th>
                <th onClick={this.onSort('EmployerName')}>
                  Employer <i className={this.setArrow('EmployerName')}> </i>
                </th>
                <th onClick={this.onSort('ExternalId')}>
                  ExternalId <i className={this.setArrow('ExternalId')}> </i>
                </th>
              </tr>
            </thead>
            <tbody>{loadCpdCompliant}</tbody>
          </table>
          {loadCpdCompliant?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SystemUsageReport);
